(function () {
    var bar = document.getElementById('HsSticky'); if (!bar) return;
    // Theme-editor guard: a section re-render leaves the previously body-moved bar
    // orphaned OUTSIDE the section (so shopify:section:unload cannot reach it), and
    // bars would otherwise accumulate one per editor save. getElementById resolves
    // the freshly-rendered in-section bar (earlier in tree order); sweep every other
    // node carrying the id. A normal storefront load matches only `bar` — no-op.
    document.querySelectorAll('#HsSticky').forEach(function (el) { if (el !== bar) el.remove(); });
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    document.body.classList.add('hs-has-sticky');
    var atc = document.getElementById('HsStickyAtc');
    var buy = document.getElementById('gokwik-buy-now');

    // Wishlist heart: the handle comes from the URL because this snippet is
    // rendered argument-less (no product in scope). Hide it off product URLs.
    var wish = document.getElementById('HsStickyWish');
    if (wish) {
      var wm = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (wm) {
        wish.setAttribute('data-handle', decodeURIComponent(wm[1]));
        // Borrow the PDP heart's variantId->paise map so a save from the
        // sticky bar captures the same variant + price as one from the
        // inline heart. Absent (e.g. a template with no buy-buttons block)
        // just means no threshold is captured — a legitimate state.
        var src = document.querySelector('.hs-wish-pdp[data-prices]');
        if (src) wish.setAttribute('data-prices', src.getAttribute('data-prices'));
      } else {
        wish.style.display = 'none';
      }
    }

    function realAdd() {
      // Scope to the main product section first: quick-add forms in related /
      // recently-viewed sections also match the generic chain below, and only
      // DOM order protected us from mirroring the wrong product (review 2026-08-21).
      return document.querySelector("[id^='MainProduct-'] button[name='add']")
        || document.querySelector("product-form button[name='add'], button[name='add'], .product-form__submit, form[action*='/cart/add'] [type='submit']");
    }
    // ⚠ 2026-10-20 audit: Dawn DISABLES the real button at the START of every option fetch
    // (product-info.js resetProductFormState → toggleSubmitButton(true), no text) and only
    // re-enables it ~300ms later — reading `disabled` alone flashed "Sold Out" on every size tap
    // and swallowed taps in that window. Sold out / unavailable is Dawn's disabled button WITH
    // Dawn's own sold-out/unavailable text (window.variantStrings); disabled with any other text
    // is "loading the new variant".
    function realDisabled(b) { return !!(b && (b.disabled || b.hasAttribute('disabled'))); }
    function realText(b) {
      var t = b && (b.querySelector('span') || b);
      return t ? (t.textContent || '').trim().toLowerCase() : '';
    }
    function soldOutWords() {
      var vs = window.variantStrings || {};
      return [(vs.soldOut || 'Sold out'), (vs.unavailable || 'Unavailable')].map(function (x) { return String(x).trim().toLowerCase(); });
    }
    // Dawn's own in-flight marker: product-info.js sets `pendingRequestUrl` when a variant fetch starts and nulls
    // it after the re-render. Needed because Dawn disables the button WITHOUT changing its text, so a fetch that
    // starts from a sold-out size still reads "Sold out" the whole time (audit 2026-10-21: taps were lost there).
    // audit 2026-10-21: a failed (non-abort) fetch leaves Dawn's marker set for good, which wedged the bar as a permanent
    // "loading" — cap it at 8s.
    var pendingSince = 0;
    function pending() {
      var pi = document.querySelector('product-info'); var p = !!(pi && pi.pendingRequestUrl != null);
      if (!p) { pendingSince = 0; return false; }
      if (!pendingSince) pendingSince = Date.now();
      return Date.now() - pendingSince < 8000;
    }
    function isSoldOut() { var b = realAdd(); return realDisabled(b) && soldOutWords().indexOf(realText(b)) !== -1 && !pending(); }
    function isLoading() { var b = realAdd(); return pending() || (realDisabled(b) && soldOutWords().indexOf(realText(b)) === -1); }

    // EVERY attribute write below is value-guarded. This is load-bearing, not style:
    // GoKwik's snippet wires MutationObservers with broad filters (incl. aria-disabled)
    // that rewrite button state unconditionally on every record. An unguarded
    // setAttribute here (which records a mutation even at an unchanged value) fed
    // those observers in a microtask cascade that WEDGED PDP parsing outright —
    // measured on staging 2026-08-11: DCL never fired until this was fixed.
    function setAttr(el, name, val) {
      if (el.getAttribute(name) !== val) el.setAttribute(name, val);
    }
    function sync() {
      // GoKwik CLONES #gokwik-buy-now when claiming it (watchSoldOutState(clone, …) in
      // their snippet), so the boot-time reference goes stale — re-resolve if detached.
      if (buy && !buy.isConnected) buy = document.getElementById('gokwik-buy-now') || buy;
      var soldOut = isSoldOut();
      // --- Add to Cart ---
      if (atc) {
        atc.classList.toggle('hs-soldout', soldOut);
        atc.disabled = soldOut;
        setAttr(atc, 'aria-disabled', soldOut ? 'true' : 'false');
        var label = soldOut ? 'Sold Out' : 'Add to Cart';
        if (atc.textContent !== label) atc.textContent = label;
      }
      // --- Buy It Now (GoKwik) ---
      if (buy) {
        if (soldOut) {
          buy.classList.add('hs-soldout', 'disabled');
          if (!buy.hasAttribute('disabled')) buy.setAttribute('disabled', 'disabled');
          setAttr(buy, 'aria-disabled', 'true');
        } else {
          buy.classList.remove('hs-soldout');
          setAttr(buy, 'aria-disabled', 'false');
          // only hand control back to GoKwik once its one-click handler exists;
          // otherwise leave it in the dim "loading" state.
          if (typeof window.onBuyNowClick === 'function') {
            buy.removeAttribute('disabled'); buy.classList.remove('disabled');
          }
        }
      }
    }

    // proxy: sticky ATC clicks the real add button (guarded — no-op when sold out)
    if (atc) atc.addEventListener('click', function (e) {
      if (isSoldOut()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      // Dawn is still fetching the newly picked variant: wait for it (≤3s), then add — a tap in
      // that window used to vanish. Decide sold-out only once the fetch has settled.
      var t0 = Date.now();
      (function go() {
        if (isLoading() && Date.now() - t0 < 6000) { setTimeout(go, 50); return; }
        if (isSoldOut()) return;
        var b = realAdd(); if (b && !realDisabled(b)) b.click();
      })();
    });
    // guard: block Buy It Now clicks while sold out (in case GoKwik briefly re-enables it).
    // Document-level DELEGATED capture: GoKwik CLONES #gokwik-buy-now when claiming it,
    // so a listener bound to the boot-time node dies with the clone (review 2026-08-21).
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#gokwik-buy-now');
      if (!t) return;
      if (isSoldOut()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    }, true);

    // Buy It Now during a size change (audit-3 2026-10-21). GoKwik's own click handler sits on WINDOW in the
    // capture phase and is registered before this file loads, so nothing on document can ever run before it —
    // the previous "hold the tap" guard here was dead code. Instead a transparent SHIELD (our own element, not
    // .gokwik-marge, so GoKwik ignores clicks on it) covers the button from the moment an option changes until
    // Dawn's variant fetch has settled. A tap on it waits for the new variant, then clicks Buy It Now for real.
    // Before: a tap in the first ~40ms went to GoKwik with the PREVIOUS size, and from ~50–350ms GoKwik's own
    // sold-out watcher (it reads Dawn's briefly-disabled button) set pointer-events:none, so the tap vanished.
    var shield = null, lastOptChange = 0, shieldPoll = null;
    function settling() { return isLoading() || Date.now() - lastOptChange < 250; }
    function placeShield() {
      var b = document.getElementById('gokwik-buy-now'); if (!b || !bar.contains(b)) return false;
      if (!shield) {
        shield = document.createElement('div'); shield.className = 'hs-sticky__shield'; shield.setAttribute('aria-hidden', 'true');
        shield.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          // audit 2026-10-26: this tap is SWALLOWED and then held for up to 6 s. Until now the
          // only feedback was `cursor: progress` on the shield, which does not exist on a phone,
          // and `hs-sticky--settling` — a class toggled in JS that had NO CSS rule anywhere. So a
          // Buy It Now tap during a size settle looked exactly like a dead button. That is the
          // same "first tap did nothing" report that got the lazy cart rolled back on 2026-10-22.
          // Mark it in the tap's OWN frame so the next paint shows it, and clear it on every exit.
          // Audit 2026-10-26: do NOT mark a sold-out tap as held — go() bails on
          // isSoldOut() a moment later and does nothing, so "Processing…" would be a
          // lie painted over "Sold out".
          if (!isSoldOut()) bar.classList.add('hs-sticky--holding');
          var t0 = Date.now();
          (function go() {
            if (settling() && Date.now() - t0 < 6000) { setTimeout(go, 50); return; }
            hideShield();
            if (isSoldOut() || isLoading()) return;
            var bb = document.getElementById('gokwik-buy-now'); if (bb && !bb.disabled) bb.click();
          })();
        });
        bar.appendChild(shield);
      }
      shield.style.left = b.offsetLeft + 'px'; shield.style.top = b.offsetTop + 'px';
      shield.style.width = b.offsetWidth + 'px'; shield.style.height = b.offsetHeight + 'px';
      shield.style.display = 'block'; bar.classList.add('hs-sticky--settling');
      return true;
    }
    function hideShield() { if (shield) shield.style.display = 'none'; bar.classList.remove('hs-sticky--settling'); bar.classList.remove('hs-sticky--holding'); }
    function armShield() {
      if (!placeShield()) return;
      clearInterval(shieldPoll);
      shieldPoll = setInterval(function () { if (!settling()) { clearInterval(shieldPoll); shieldPoll = null; hideShield(); } }, 50);
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) { lastOptChange = Date.now(); armShield(); }
    }, true);

    // React to variant changes: watch the real add button + option inputs.
    var real = realAdd();
    if (real && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(real, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest("variant-selects, variant-radios, .product-form, form[action*='/cart/add']")) setTimeout(sync, 60);
    });

    // GoKwik's gokwikLoaded handler unconditionally re-enables #gokwik-buy-now, so
    // re-assert sold-out around its ready signal instead of drumming a 350ms poll
    // through the PDP's critical load window. gokwikLoaded dispatches on WINDOW
    // (verified from GoKwik's own snippet); the document listener is a belt in case
    // a future SDK moves it. The initial sync() below covers the event having fired
    // BEFORE this script attached — sync() re-derives state from the real add button,
    // so ordering never matters, only "did a sync run after the re-enable".
    // DELIBERATELY NO MutationObserver on the GoKwik button: GoKwik's own
    // watchSoldOutState observer now mirrors sold-out onto it (so ours duplicated
    // theirs), and observer-vs-observer attribute traffic is exactly what wedged
    // the PDP — see the setAttr note above. The residual poll below is the only
    // non-event layer, and it terminates.
    var gkFallback = false;
    function gkResync() {
      // If GoKwik arrives AFTER the 6s fallback armed, hand the button back:
      // the flag neutralises the fallback listener (GoKwik's clone-on-claim
      // usually also discards it, but that behaviour is theirs, not a contract).
      if (gkFallback && typeof window.onBuyNowClick === 'function') {
        gkFallback = false;
        // Restore the inline handler the fallback cleared, so GoKwik owns the
        // click again even if it claimed the button WITHOUT cloning it.
        var gb = document.getElementById('gokwik-buy-now');
        if (gb && gb.getAttribute('onclick') === '') gb.setAttribute('onclick', 'onBuyNowClick(this)');
      }
      sync(); setTimeout(sync, 500);
    }
    window.addEventListener('gokwikLoaded', gkResync);
    document.addEventListener('gokwikLoaded', gkResync);
    sync();
    // Residual net: 3 ticks, not the old 25 — the event path does the real work.
    var n = 0, iv = setInterval(function () { sync(); if (++n > 2) clearInterval(iv); }, 500);

    // Fallback: if GoKwik never loads, make Buy It Now add-to-cart instead (only when available).
    setTimeout(function () {
      if (buy && typeof window.onBuyNowClick !== 'function' && !isSoldOut()) {
        gkFallback = true;
        buy.removeAttribute('disabled'); buy.classList.remove('disabled');
        buy.setAttribute('onclick', '');
        buy.addEventListener('click', function () { if (!gkFallback) return; if (isSoldOut()) return; var b = realAdd(); if (b) b.click(); });
      }
    }, 6000);
  })();
